import { render, staticRenderFns } from "./inventoryComponent.vue?vue&type=template&id=1425b63f&scoped=true"
import script from "./inventoryComponent.vue?vue&type=script&lang=js"
export * from "./inventoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425b63f",
  null
  
)

export default component.exports